import AntdTooltip from 'antd/lib/tooltip';
import CustomTooltip from './customTooltip';
var Tooltip = AntdTooltip;
Tooltip.CustomTooltip = CustomTooltip;
export default Tooltip;